import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import kubernetesPlugin from '@backstage/plugin-kubernetes/alpha';
// Explicit registration — `packages: all` discovery proved unreliable in
// the production bundle (techdocs /docs route 404'd on v0.3.0).
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
import searchPlugin from '@backstage/plugin-search/alpha';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';
import orgPlugin from '@backstage/plugin-org/alpha';
import userSettingsPlugin from '@backstage/plugin-user-settings/alpha';
import catalogImportPlugin from '@backstage/plugin-catalog-import/alpha';
import visualizerPlugin from '@backstage/plugin-app-visualizer';
import notificationsPlugin from '@backstage/plugin-notifications/alpha';
import { navModule } from './modules/nav';
import { signInModule } from './modules/signIn';

export default createApp({
  features: [
    catalogPlugin,
    kubernetesPlugin,
    techdocsPlugin,
    searchPlugin,
    apiDocsPlugin,
    catalogGraphPlugin,
    orgPlugin,
    userSettingsPlugin,
    catalogImportPlugin,
    visualizerPlugin,
    notificationsPlugin,
    navModule,
    signInModule,
  ],
});
